// src/modules/smelter/constants.js
// HSN codes billed to smelters on the GST tax invoice, per metal. Mirrors
// crm-backend/constants/metals.js — the backend applies the same defaults when a
// line item arrives without an HSN. Line items stay editable on the forms.

export const HSN_BY_METAL = {
  GOLD: '71081200',
  SILVER: '711311',
};

export const hsnForMetal = (metalType) =>
  HSN_BY_METAL[String(metalType || '').toUpperCase()] || HSN_BY_METAL.GOLD;

// Default line description that pairs with the HSN above.
export const goodsDescriptionForMetal = (metalType) =>
  String(metalType || '').toUpperCase() === 'SILVER' ? 'Old melted Silver' : 'Old melted Gold';

export const METAL_OPTIONS = [
  { value: 'GOLD', label: 'Gold' },
  { value: 'SILVER', label: 'Silver' },
];
